import { initializeApp } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import firebaseConfig from "../utils/firebase";
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const signOutFirebase = async (): Promise<void> => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("[Auth] Error signing out from Firebase:", error);
  }
};
